
  export default {
    data() {
      return {
        boosterCampaigns: [
          {
            color: '#E4BF7B',
            name: 'Booster-Kampagne XS',
            description: 'Budget für <b>bis zu 100</b> zusätzliche Bewerbungen',
            price: '990,00 €',
          },
          {
            color: '#DCA441',
            name: 'Booster-Kampagne S',
            description: 'Budget für <b>bis zu 150</b> zusätzliche Bewerbungen',
            price: '1.490,00 €',
          },
          {
            color: '#6E8DB5',
            name: 'Booster-Kampagne M',
            description: 'Budget für <b>bis zu 200</b> zusätzliche Bewerbungen',
            price: '1.990,00 €',
          },
          {
            color: '#6E8DB5',
            name: 'Booster-Kampagne L',
            description: 'Budget für <b>bis zu 250</b> zusätzliche Bewerbungen',
            price: '2.490,00 €',
          },
          {
            color: '#3D6190',
            name: 'Booster-Kampagne XL',
            description: 'Budget für <b>bis zu 300</b> zusätzliche Bewerbungen',
            price: '2.990,00 €',
          },
        ],
      };
    },
  };
